export const CANDLE_LEFT = 'https://images.fallenlondon.com/css_img/candle01BG.png';
export const CANDLE_RIGHT = 'https://images.fallenlondon.com/css_img/candle02BG.png';

export const CANDLE_TOP = 'https://images.fallenlondon.com/css_img/candleTop.png';
export const CANDLE_SNUFFED = '//images.fallenlondon.com/css_img/candleSnuffed.png';
